import { createSelector } from '@ngrx/store';
import * as fromOutstandingReducer from '../reducers/outstanding.reducer';
import * as fromPaymentRunsState from '../reducers';

export const selectOutstanding = createSelector(
  fromPaymentRunsState.selectOutstandingState,
  (state) => state ? fromOutstandingReducer.getOutstanding(state) : null
);

export const selectOutstandingLoading = createSelector(
  fromPaymentRunsState.selectOutstandingState,
  (state) => state ? fromOutstandingReducer.getOutstandingLoading(state) : false
);

export const selectOutstandingError = createSelector(
  fromPaymentRunsState.selectOutstandingState,
  (state) => state ? fromOutstandingReducer.getOutstandingError(state) : null
);

export const selectOutstandingMembers = createSelector(
  selectOutstanding,
  (outstanding) => outstanding?.outstandingMembers || []
);

export const selectOutstandingTotalCount = createSelector(
  selectOutstanding,
  (outstanding) => outstanding?.totalCount || 0
);

export const selectOutstandingTotalOutstanding = createSelector(
  selectOutstanding,
  (outstanding) => outstanding?.totalOutstanding || 0
);

export const selectOutstandingTotalAmountDue = createSelector(
  selectOutstanding,
  (outstanding) => outstanding?.totalAmountDue || 0
);

export const selectOutstandingTotalRefundAmount = createSelector(
  selectOutstanding,
  (outstanding) => outstanding?.totalRefundAmount || 0
);
